import { message } from "antd";
import { MediaPurpose } from "@/utils/enum";
import { updateDocument } from "@/services/media";

export const GATEPASS_MIME_TYPES = [
  "text/csv",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/pdf",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/gif",
  "image/jpeg",
  "image/png",
  "image/svg+xml",
  "image/bmp",
];

export async function uploadGatePass(file) {
  if (!file.length === 0) {
    return "No file selected";
  }

  // We limit the file types on the upload component, but double check here
  if (!GATEPASS_MIME_TYPES.includes(file[0].type)) {
    return "Invalid file type";
  }

  try {
    const gatePassPayload = await updateDocument(file[0].originFileObj, MediaPurpose.GatePass);

    return gatePassPayload;
  } catch (error) {
    console.error(error);
    message.error("Something went wrong when trying to upload the gate pass, please try again later.");
    return { error: true };
  }
}
